import React, { useState } from 'react';

const NewDevices = ()=>{
  const [task, setTask] = useState("");
  const [tasksList, setTasksList] = useState([]);

  const handleTaskInputChange = (event) => {
    setTask(event.target.value);
  };

  const handleAddTaskClick = () => {
    if (task.trim() !== "") {
      setTasksList([...tasksList, task.trim()]);
      setTask("");
    }
  };

  const handleDeleteTaskClick = (index) => {
    const newTasksList = [...tasksList];
    newTasksList.splice(index, 1);
    setTasksList(newTasksList);
  };
    
  
    return(
        <div>
        <u><h4 className='newDevice-heading'>Device Information</h4></u>
        <hr />
        <div className='newDevice-main'>
        <div className='newDevice-dropDown'>
        <lable className='new-lable'>Devices</lable><br/>
        <select className='new-select'>
            <option>T.V</option>
            <option>Mobile</option>
            <option>Laptop</option>
            <option>I pad</option>
        </select>
        </div>
        <div className='newDevice-dropDown'>
        <lable className='new-lable2'>Distributor Name</lable><br/>
        <select className='new-select2'>
            <option>Peter</option>
            <option>Yasir</option>
            <option>demo</option>
            <option>test</option>
            <option>check</option>
            <option>temp</option>
        </select>
        </div>
        <div>
      <h1>Todo List</h1>
      <ul>
        {tasksList.map((task, index) => (
          <li key={index}>
            {task}
            <button onClick={() => handleDeleteTaskClick(index)}>Delete</button>
          </li>
        ))}
      </ul>
      <div>
        <input type="text" value={task} onChange={handleTaskInputChange} />
        <button onClick={handleAddTaskClick}>Add Task</button>
      </div>
    </div>
        
        </div>
        </div>
    )
}
export default NewDevices;